import React, { useState, useEffect } from "react";
import { Building2 } from "lucide-react";
import api, { notifyError } from "@/lib/api";
import TenantOverrideEditor from "./TenantOverrideEditor";

export default function TenantOverrideTab() {
  const [tenants, setTenants] = useState([]);
  const [selectedId, setSelectedId] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/platform/tenants").then((r) => {
      const items = r.data.items || [];
      setTenants(items);
      if (items.length && !selectedId) setSelectedId(items[0].tenant_id);
    }).catch(notifyError).finally(() => setLoading(false));
    // Intentionally run once on mount; selectedId auto-set from first item only when empty.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div data-testid="tab-tenant-override">
      <div className="mb-4">
        <label className="block text-[11px] font-bold text-white/60 uppercase tracking-wider mb-1.5">Pilih Tenant</label>
        <div className="flex flex-wrap gap-2" data-testid="tenant-picker">
          {loading ? (
            <div className="text-white/40 text-sm">Memuat tenant…</div>
          ) : tenants.length === 0 ? (
            <div className="text-white/40 text-sm">Belum ada tenant.</div>
          ) : tenants.map((t) => (
            <button key={t.tenant_id} onClick={() => setSelectedId(t.tenant_id)}
              className={`px-3 py-1.5 rounded-full text-xs font-bold border flex items-center gap-1.5 transition-colors ${
                selectedId === t.tenant_id ? "bg-white text-black border-white" : "border-white/10 text-white/70 hover:text-white hover:border-white/30"
              }`}
              data-testid={`tenant-pick-${t.tenant_slug}`}>
              <Building2 size={12} /> {t.tenant_name}
              <span className="font-mono text-[10px] opacity-60">{t.tenant_code}</span>
            </button>
          ))}
        </div>
      </div>

      {selectedId && <TenantOverrideEditor tenantId={selectedId} />}
    </div>
  );
}
